import { useState } from "react";
import JSLayout from "./js_layout";

const portfolioCss = `
  .pf-upload-area { border:2px dashed rgba(var(--color-primary-rgb),0.35); border-radius:4px; padding:2.5rem; text-align:center; cursor:pointer; transition:all 0.2s; background:#fff; margin-bottom:1.5rem; }
  .pf-upload-area:hover { border-color:var(--color-primary); background:rgba(var(--color-primary-rgb),0.03); }
  .pf-upload-icon { font-size:2rem; margin-bottom:0.75rem; }
  .pf-upload-title { font-family: 'DM Sans', sans-serif; font-size:1.2rem; font-weight:600; color:var(--color-text); margin-bottom:0.4rem; }
  .pf-upload-sub { font-size:0.8rem; color:#aaa; font-weight:300; }
  .pf-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:1rem; }
  .pf-item { background:#fff; border:1px solid rgba(var(--color-text-rgb),0.07); border-radius:4px; overflow:hidden; }
  .pf-thumb { height:160px; display:flex; align-items:center; justify-content:center; font-size:3rem; background:var(--color-bg-subtle); }
  .pf-item-body { padding:0.85rem 1rem; }
  .pf-item-title { font-size:0.85rem; font-weight:500; color:var(--color-text); margin-bottom:2px; }
  .pf-item-desc { font-size:0.75rem; color:#aaa; font-weight:300; }
  .pf-item-actions { display:flex; gap:0.5rem; margin-top:0.65rem; }
  .pf-item-btn { font-size:0.65rem; padding:4px 10px; border-radius:2px; cursor:pointer; font-family:'DM Sans',sans-serif; border:1px solid rgba(var(--color-text-rgb),0.1); background:none; color:#888; transition:all 0.2s; }
  .pf-item-btn:hover { border-color:var(--color-primary); color:var(--color-primary); }
  .pf-item-btn.danger:hover { border-color:#e74c3c; color:#e74c3c; }
  @media(max-width:768px){ .pf-grid{grid-template-columns:repeat(2,1fr);} }
  @media(max-width:500px){ .pf-grid{grid-template-columns:1fr;} }
`;

const PORTFOLIO_ITEMS = [
  { id:1, thumb:"✂️", title:"Balayage transformation", desc:"Before & after colour correction" },
  { id:2, thumb:"💇", title:"Textured bob cut", desc:"Natural hair styling" },
  { id:3, thumb:"🎨", title:"Vivid colour — copper", desc:"Full head copper tone" },
  { id:4, thumb:"👩‍🦱", title:"Protective braids", desc:"Box braids with extensions" },
  { id:5, thumb:"✨", title:"Keratin treatment", desc:"Frizz control & smoothing" },
];

export function Portfolio() {
  const [items, setItems] = useState(PORTFOLIO_ITEMS);
  if (typeof document !== "undefined" && !document.getElementById("bl-pf-css")) {
    const s = document.createElement("style"); s.id="bl-pf-css"; s.textContent=portfolioCss; document.head.appendChild(s);
  }
  return (
    <JSLayout title="My" titleEm="Portfolio">
      <div className="pf-upload-area">
        <div className="pf-upload-icon">📸</div>
        <div className="pf-upload-title">Add to your portfolio</div>
        <div className="pf-upload-sub">Upload photos of your work — JPG, PNG up to 10MB each<br/>A strong portfolio increases your match rate by up to 40%</div>
      </div>
      <div className="bl-section-hdr"><div className="bl-section-title">Your <em>work</em></div><span style={{ fontSize:"0.8rem", color:"#aaa" }}>{items.length} items</span></div>
      <div className="pf-grid">
        {items.map(item => (
          <div key={item.id} className="pf-item">
            <div className="pf-thumb">{item.thumb}</div>
            <div className="pf-item-body">
              <div className="pf-item-title">{item.title}</div>
              <div className="pf-item-desc">{item.desc}</div>
              <div className="pf-item-actions">
                <button className="pf-item-btn">Edit</button>
                <button className="pf-item-btn danger" onClick={() => setItems(prev => prev.filter(i => i.id !== item.id))}>Remove</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </JSLayout>
  );
}